import { downscale, quality } from "@core/Utils/HelperFunction";
import { Phase } from "@core/Logic/Logic";
import { Constants, effectsVolume } from "@core/Utils/Constants"
import * as Icons_SVG from "@core/GUI/Utils/IconsSVG";
import { Language, Messages } from "@core/GUI/Language";
import { Client } from "@core/Client";

/**
 * A class for a video object where the user cannot move the video player around.
 * The video object can only be enlarged via a click or touch gesture.
 */
export class VideoFeedStatic extends Phaser.GameObjects.Container {
	constructor(_videoContainer: string, scene: Phaser.Scene) {
		super(scene)
		this.videoContainer = document.getElementById(_videoContainer)
		this.videoContainer.style.transition = "all .7s ease-in-out"
		this.videoContainer.style.webkitTransition = "all .7s ease-in-out"
		this.videoContainer.style.transformOrigin = "50% 0%"
		this.videoContainer.style.webkitTransformOrigin = "50% 0%"
		this.videoContainer.style.transform = "translate(-50%, 0%)"
		this.videoContainer.style.webkitTransform = "translate(-50%, 0%)"
		this.videoContainer.style.left = "50%"
		this.visible = false

		this.sourceDimensions.height = parseInt((this.videoContainer.firstChild as HTMLIFrameElement).height)
		this.sourceDimensions.widht = parseInt((this.videoContainer.firstChild as HTMLIFrameElement).width)

		let f = (event: any) => {
			if (this.chatBox)
				this.chatBox.handler(event);

			event.stopImmediatePropagation()
			event.stopPropagation()
			event.preventDefault()
		}

		// https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
		// The browser may fire both touch events and mouse events in response to the same user input
		this.videoContainer.addEventListener("mousedown", (e) => { this.handleDown(e) })
		this.videoContainer.addEventListener("mouseup", (e) => { f(e) })
		this.videoContainer.addEventListener("mousemove", (e) => { f(e) })
		this.videoContainer.addEventListener("mouseout", (e) => { f(e) })
		this.videoContainer.addEventListener("touchstart", (e) => { this.handleDown(e) })
		this.videoContainer.addEventListener("touchend", (e) => { this.handleTouchDown(e) })
		this.videoContainer.addEventListener("touchcancel", (e) => { f(e) })
		this.videoContainer.addEventListener("touchmove", (e) => { f(e) })
		this.videoContainer.addEventListener("pointerout", (e) => { f(e) })

		this.scene.game.events.on("videoVolumeChanged", (value: number) => { this.setVideoVolume(value); })
		this.scene.game.events.on(Constants.EVENTS.VIDEO_ZOOM_IN, (zoomLevel: number) => { this.zoomInEvent(zoomLevel) })
		this.scene.game.events.on("hideVideo", (forced) => { this.Hide(forced) })
		this.scene.game.events.on("showVideo", () => { this.Show() })
		this.scene.game.events.on(Constants.EVENTS.LATENCY_TOO_HIGH, () => {
			let connection_blinker_element = (document.getElementsByClassName('unstable-connection-blinker')[0] as HTMLElement);
			if (connection_blinker_element) {
				connection_blinker_element.style.visibility = "visible";
			}
			if (this.domLatencyTimeout) clearTimeout(this.domLatencyTimeout)
			this.domLatencyTimeout = setTimeout(() => {
				//if(document.getElementsByClassName('unstable-connection-blinker')[0].style.visibility == "visible") document.getElementsByClassName('unstable-connection-blinker')[0].style.visibility = "hidden";
				let connection_blinker_element = (document.getElementsByClassName('unstable-connection-blinker')[0] as HTMLElement);
				if (connection_blinker_element) connection_blinker_element.style.visibility = "hidden";
			}, 2500)
		})

		// this.videoContainer.innerHTML = this.HTML.replace('name=""', "name='" + JSON.stringify(this.logic.Stream) + "'");
		if (this.scene.game.device.os.iOS) window.AUDIO_CONTEXT = (this.scene.sound as Phaser.Sound.WebAudioSoundManager).context
	}

	protected setVideoVolume(value: number): void {
		if (this.videoContainer && this.videoContainer.getElementsByTagName("iframe")[0]) {
			// this.videoContainer.getElementsByTagName("iframe")[0].contentWindow.TryUnlockingAudio()
			let iframe = (this.videoContainer.getElementsByTagName("iframe")[0].contentWindow as any)
			if (iframe && iframe.TryUnlockingAudio) iframe.SetVolume(value);
		}
	}

	/**
	 * TODO:
	 * TRACK STATES IF AUTO_ZOOM_1 then allow user to click to return it to the previous phase
	 */
	handleDown(e): void {
		e.stopImmediatePropagation()
		e.stopPropagation()
		e.preventDefault()

		if (this.chatBox)
			this.chatBox.handler(e);

		if (e.target.id == "path0" || e.target.id == "playButton" || e.target.id == "pathPlayButton") {
			this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS, { volume: 0.45 * effectsVolume })
			this.PlayVideo()
			return
		}

		if (e.target.id == "global_mute_unmute_button") {
			let mute = this.scene.sound.mute
			if (mute) {
				this.scene.registry.set("is_game_muted", false)
				this.UnMuteAudioIFrame()
				this.scene.sound.mute = false
				this.switchSpeakerIcon(false)
			} else {
				this.scene.registry.set("is_game_muted", true)
				this.MuteAudioIFrame()
				this.scene.sound.mute = true
				this.switchSpeakerIcon(true)
			}
			return
		}

		if (e.target.id == "stop_video_button") {
			this.zoomInEvent(-1)
			this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS, { volume: 0.45 * effectsVolume })
			this.StopVideo()
			return
		}

		if (e.target.id == "refresh_video_button") {
			this.scene.game.events.emit("refreshVideoScale")
			// this.Hide()
			// this.Show()
			if (this.scene.game.device.os.iOS) {
				this.Hide()
				this.Show()
				this.TryUnlockingAudioAfterGesture()
			} else {
				this.scene.scale.toggleFullscreen()
			}
			return
		}
		// let iframe = ((this.videoContainer.firstChild as HTMLIFrameElement).contentWindow as any)

		// Prevent zooming of video frame on user gesture if showing silhouette
		if (!this.softHidden && !this.visible || this.silhouetteVisible)
			return

		// Close menu dialog if it exits and it is visible 
		if (this.scene && this.scene.menuDialog && this.scene.menuDialog.visible) {
			this.scene.menuDialog.setVisible(false)
		}

		// Close presets dialog if it exists and it is visible
		if (this.scene && this.scene.miscButtons && this.scene.miscButtons.visible) {
			this.scene.miscButtons.TogglePresetsVisibility()
		}

		this.scene.sound.play(Constants.SOUNDS.MENU_VALIDATE, { volume: 0.20 * effectsVolume })
		switch (this.zoomPointer) {
			case -1:
				this.zoomPointer = 0
				this.updateIFrameScale(this.zoomLevels[0])
				break;
			case 0:
				this.zoomPointer = 1
				this.updateIFrameScale(this.zoomLevels[1])
				break;
			default:
				this.zoomPointer = -1
				this.updateIFrameScale(this.savedScale)
				break;
		}
	}

	handleTouchDown(e: any): void {
		e.stopImmediatePropagation()
		e.stopPropagation()
		// Crucial otherwise zoom gets called twice on mobile
		e.preventDefault()
		if (this.scene.game.device.os.iOS) setTimeout(() => this.TryUnlockingAudioAfterGesture(), 500)
	}

	get X(): number {
		return this.videoContainer.getBoundingClientRect().x
	}

	get Y(): number {
		return this.videoContainer.getBoundingClientRect().y
	}

	get Width(): number {
		// return Math.ceil((this.videoContainer.firstChild as HTMLIFrameElement).getBoundingClientRect().width)
		//return parseInt((this.videoContainer.firstChild as HTMLIFrameElement).width)
		return this.videoContainer.getBoundingClientRect().width * this.savedScale;
	}

	get Height(): number {
		//return parseInt((this.videoContainer.firstChild as HTMLIFrameElement).height)
		return this.videoContainer.getBoundingClientRect().height * this.savedScale;
	}

	get Visible(): boolean {
		return this.visible
	}

	get SoftHidden(): boolean {
		return this.softHidden
	}

	/**
	 * Due to iOS web audio autoplay prevention we use this function
	 * which calls another function defined in the iframe itself.
	 */
	TryUnlockingAudioAfterGesture(): void {
		/*
		// Change the target child if we are planning to user more than zero video player control buttons
		if (this.videoContainer && this.videoContainer.children[1]) {
			let iframe = ((this.videoContainer.children[2] as HTMLIFrameElement).contentWindow as any)
			if(iframe && iframe.TryUnlockingAudio) iframe.TryUnlockingAudio()
		}
		*/
		if (this.videoContainer && this.videoContainer.getElementsByTagName("iframe")[0]) {
			// this.videoContainer.getElementsByTagName("iframe")[0].contentWindow.TryUnlockingAudio()
			let iframe = (this.videoContainer.getElementsByTagName("iframe")[0].contentWindow as any)
			if (iframe && iframe.TryUnlockingAudio) iframe.TryUnlockingAudio()
		}
	}

	MuteAudioIFrame(): void {
		if (this.videoContainer && this.videoContainer.getElementsByTagName("iframe")[0]) {
			let iframe = (this.videoContainer.getElementsByTagName("iframe")[0].contentWindow as any)
			if (iframe && iframe.MuteAudio) iframe.MuteAudio();
		}
	}

	UnMuteAudioIFrame(): void {
		if (this.videoContainer && this.videoContainer.getElementsByTagName("iframe")[0]) {
			let iframe = (this.videoContainer.getElementsByTagName("iframe")[0].contentWindow as any)
			if (iframe && iframe.UnMuteAudio) iframe.UnMuteAudio();
		}
	}

	StopVideo(): void {
		this.videoContainer.innerHTML = this.silhouetteHTML + this.voidWarningDIV
		this.silhouetteVisible = true
	}

	PlayVideo(): void {
		this.silhouetteVisible = false
		this.Show()
	}

	Show(): void {
		if (Client.logic.Phase == Phase.ERROR_OR_DISCONNECTED) {
			this.Hide()
			return
		}

		this.videoContainer.style.display = "block"

		if (this.silhouetteVisible) {
			this.videoContainer.innerHTML = this.silhouetteHTML + this.voidWarningDIV
		} else {
			let muted = this.scene.registry.get("is_game_muted")
			let videoURL = Client.logic.Stream.videoURL
			let audioURL = Client.logic.Stream.audioURL
			this.videoContainer.innerHTML = this.HTML.replace('name=""', "name='" + JSON.stringify({ videoURL: videoURL, audioURL: audioURL, muted: muted }) + "'");
			this.switchSpeakerIcon(muted);
		}

		// this.videoContainer.firstElementChild.setAttribute("name", JSON.stringify(this.logic.Stream))
		// this.videoContainer.setAttribute("name", JSON.stringify(this.logic.Stream))
		this.visible = true
		this.softHidden = false
	}

	Hide(forced?: boolean): void {
		// Zoom back before silhouette is enabled
		if (Client.logic.Phase == Phase.ERROR_OR_DISCONNECTED) this.zoomInEvent(-1)
		// this.videoContainer.style.display = "none"
		if (forced) this.videoContainer.innerHTML = "";
		else this.videoContainer.innerHTML = this.silhouetteHTML + this.voidWarningDIV
		this.visible = false
		this.softHidden = false
	}

	SoftShow(): void {
		if (Client.logic.Phase == Phase.ERROR_OR_DISCONNECTED) {
			this.Hide()
			return
		}
		this.videoContainer.style.display = "block"
		this.visible = true
		this.softHidden = false
	}

	/**
	 * Hide without destroying the player
	 */
	SoftHide(): void {
		this.videoContainer.style.display = "none"
		this.visible = false
		this.softHidden = true
	}

	Toggle(): void {
		this.visible ? this.Hide() : this.Show()
	}

	UpdatePositions(bounds: Phaser.Geom.Rectangle, viewWidth?: number, viewHeight?: number, portraitMode?: boolean): void {
		this.viewHeight = viewHeight;
		this.viewWidth = viewWidth;
		this.portraitMode = portraitMode;

		// Downscale usage here must be equal to the one used in helper function class
		let hScale = bounds.height / ((this.videoHeight + 2 * this.borderSize) * (Math.max(0.5, downscale) * quality))
		let wScale = bounds.width / ((this.videoWidth + 2 * this.borderSize) * (Math.max(0.5, downscale) * quality))

		let _scale = Math.min(hScale, wScale)

		this.savedScale = (_scale / window.devicePixelRatio)

		this.videoContainer.style.transform = "translate(-50%, 0%) scale(" + this.savedScale + ")";

		if (portraitMode) {
			this.videoContainer.style.transform = "translate(-50%, 0%) rotate3d(0, 0, 1, 90deg) scale(" + this.savedScale + ")";
			this.videoContainer.style.webkitTransform = "translate(-50%, 0%) rotate3d(0, 0, 1, 90deg) scale(" + this.savedScale + ")";
			this.videoContainer.style.left = "100%"
			this.videoContainer.style.top = "50%"
		} else {
			this.videoContainer.style.left = "50%"
			this.videoContainer.style.top = ""
		}

		this.saveCurrentPosition((-this.padding / window.devicePixelRatio), (_scale / window.devicePixelRatio));
		this.saveCurrentSize((this.videoWidth * (_scale / window.devicePixelRatio)), (this.videoHeight * (_scale / window.devicePixelRatio)));

		if (this.scene.game.device.os.android) {
			if (!this.scene.scale.isFullscreen) {
				let fullscreen_icon_element = document.getElementById("video_game_fullscreen_button")
				if (fullscreen_icon_element) {
					fullscreen_icon_element.style.display = "block"
				}
			} else {
				let fullscreen_icon_element = document.getElementById("video_game_fullscreen_button")
				if (fullscreen_icon_element) {
					fullscreen_icon_element.style.display = "none"
				}
			}
		}
	}

	CalculateWidthFromScale(scale: number): number {
		let _scale = scale / this.videoHeight;
		return (this.videoWidth * _scale);
	}

	protected switchSpeakerIcon(muted: boolean): void {
		if (muted) {
			let html = `<img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" 
						style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);"
						width="50px" id="global_mute_unmute_button" src='data:image/svg+xml;utf8,${Icons_SVG.SpeakerOff}' />`
			document.getElementById("global_mute_unmute_button").innerHTML = html
		} else {
			let html = `<img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable"
						style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" 
						width="50px" id="global_mute_unmute_button" src='data:image/svg+xml;utf8,${Icons_SVG.SpeakerOn}' />`
			document.getElementById("global_mute_unmute_button").innerHTML = html
		}
	}

	protected zoomInEvent(zoomLevel: number): void {
		// To prevent video from zooming and going over the menu dialog if the menu dialog exists
		if (this.scene && this.scene.menuDialog && this.scene.menuDialog.visible) return

		// Uncomment if it causes issues!
		// if (!this.visible) return
		if (zoomLevel == -1) {
			// this.videoContainer.style.transform = "translate(-50%, 0%) scale("+this.savedScale+")"
			// this.videoContainer.style.webkitTransform = "translate(-50%, 0%) scale("+this.savedScale+")"
			this.autoZoomed = false
			this.zoomPointer = -1
			this.updateIFrameScale(this.savedScale)
		}
		else {
			this.autoZoomed = true
			this.zoomPointer = 1
			this.updateIFrameScale(this.zoomLevels[1])
		}
	}

	protected updateIFrameScale(zoomTo: number): void {
		if (this.silhouetteVisible) return
		if (zoomTo == this.savedScale) {
			this.videoContainer.style.transform = "translate(-50%, 0%) scale(" + this.savedScale + ")"
			this.videoContainer.style.webkitTransform = "translate(-50%, 0%) scale(" + this.savedScale + ")"
			if (this.portraitMode) {
				this.videoContainer.style.transform = "translate(-50%, 0%) rotate3d(0, 0, 1, 90deg) scale(" + this.savedScale + ")"
				this.videoContainer.style.webkitTransform = "translate(-50%, 0%) rotate3d(0, 0, 1, 90deg) scale(" + this.savedScale + ")"
				this.videoContainer.style.left = "100%"
				this.videoContainer.style.top = "50%"
			} else {
				this.videoContainer.style.left = "50%"
				this.videoContainer.style.top = ""
			}
		} else {
			let scale;
			if (this.portraitMode) {
				scale = zoomTo * this.getMaxScale([window.innerHeight, window.innerWidth], [this.videoWidth, this.videoHeight])
			}
			else {
				scale = zoomTo * this.getMaxScale([window.innerWidth, window.innerHeight], [this.videoWidth, this.videoHeight])
			}
			this.videoContainer.style.transform = "translate(-50%, 0%) scale(" + scale + ")"
			this.videoContainer.style.webkitTransform = "translate(-50%, 0%) scale(" + scale + ")"
			if (this.portraitMode) {
				this.videoContainer.style.transform = "translate(-50%, 0%) rotate3d(0, 0, 1, 90deg) scale(" + scale + ")"
				this.videoContainer.style.webkitTransform = "translate(-50%, 0%) rotate3d(0, 0, 1, 90deg) scale(" + scale + ")"
				this.videoContainer.style.left = "100%"
				this.videoContainer.style.top = "50%"
			} else {
				this.videoContainer.style.left = "50%"
				this.videoContainer.style.top = ""
			}
		}
	}

	protected getMaxScale(containerDimensions: [number, number], childDimensions: [number, number]): number {
		const [containerWidth, containerHeight] = containerDimensions
		const [childWidth, childHeight] = childDimensions

		const maxWidthScale = containerWidth / childWidth
		const maxHeightScale = containerHeight / childHeight

		const maxScale = Math.min(maxWidthScale, maxHeightScale)
		return maxScale
	}

	protected saveCurrentPosition(x: number, y: number): void {
		this.currentX = x;
		this.currentY = y;
	}

	protected saveCurrentSize(width: number, height: number): void {
		this.currentWidth = width;
		this.currentHeight = height;
	}

	/**
	 * zoomPointer: 
	 *  -1 if this.savedScale
	 *   0 if 0.5
	 *   1 if 0.8
	 */
	public chatBox: any;

	protected viewWidth: number = window.innerWidth;
	protected viewHeight: number = window.innerHeight;
	protected portraitMode: boolean = false;

	protected zoomPointer = -1
	protected zoomLevels = [0.5, 0.8]
	protected autoZoomed = false
	protected savedScale = 1
	protected zoomed = false
	protected softHidden = false
	protected currentX: number = 0;
	protected currentY: number = 0;
	protected currentWidth: number = 0;
	protected currentHeight: number = 0;
	protected padding: number = 20
	protected videoWidth = 480
	// 1920x1080
	// private videoHeight = 270
	// 1920x1200
	protected videoHeight = 300
	protected borderSize = 1 * window.devicePixelRatio
	protected borderColor = "#0000008c"
	protected iconOpacity = 0.85
	private domLatencyTimeout: number;
	// Calc - 75px due to the latency warning icon width * 2 = 75px
	// SVG ViewBox magic number = 14 in this case
	// Magic number * number of characters in the warning text
	protected warningText = Language.Get(Messages.CONNECTION_IS_BAD)
	protected textSVG = `
					<svg style="width: calc(100% - 75px);" viewBox="0 0 ${(this.warningText.length * Math.ceil(509 / 36))} 30">
						<text style="fill: white;" x="50%" text-anchor="middle" y="29">${this.warningText}</text>
					</svg>
	`
	protected latencyWarningIcon = '<img class="warning-indicator blinking-element" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgYmFzZVByb2ZpbGU9InRpbnkiIGhlaWdodD0iMjRweCIgaWQ9IkxheWVyXzEiIHZlcnNpb249IjEuMiIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGc+PHBhdGggZD0iTTEyLDUuNTExYzAuNTYxLDAsMS4xMTksMC4zNTQsMS41NDQsMS4wNjJsNS45MTIsOS44NTRDMjAuMzA3LDE3Ljg0MiwxOS42NSwxOSwxOCwxOUg2Yy0xLjY1LDAtMi4zMDctMS4xNTktMS40NTYtMi41NzMgICBsNS45MTItOS44NTRDMTAuODgxLDUuODY1LDExLjQzOSw1LjUxMSwxMiw1LjUxMSBNMTIsMy41MTFjLTEuMjk2LDAtMi40ODIsMC43NC0zLjI1OSwyLjAzMWwtNS45MTIsOS44NTYgICBjLTAuNzg2LDEuMzA5LTAuODcyLDIuNzA1LTAuMjM1LDMuODNTNC40NzMsMjEsNiwyMWgxMmMxLjUyNywwLDIuNzctMC42NDYsMy40MDYtMS43NzFzMC41NTEtMi41MjEtMC4yMzUtMy44M2wtNS45MTItOS44NTQgICBDMTQuNDgyLDQuMjUxLDEzLjI5NiwzLjUxMSwxMiwzLjUxMXoiLz48L2c+PGc+PGNpcmNsZSBjeD0iMTIiIGN5PSIxNiIgcj0iMS4zIi8+PC9nPjxnPjxwYXRoIGQ9Ik0xMy41LDEwYzAtMC44My0wLjY3MS0xLjUtMS41LTEuNXMtMS41LDAuNjctMS41LDEuNWMwLDAuMTk5LDAuMDQxLDAuMzg5LDAuMTExLDAuNTYyQzExLjE2NSwxMS45MzgsMTIsMTQsMTIsMTQgICBzMC44MzUtMi4wNjIsMS4zOTEtMy40MzhDMTMuNDU5LDEwLjM4OSwxMy41LDEwLjE5OSwxMy41LDEweiIvPjwvZz48L3N2Zz4=" />'
	// Hackish style addition to leftmost latency warning icon by replacing part of the string
	protected latencyWarning = '<div class="unstable-connection-blinker">' + this.latencyWarningIcon.replace('blinking-element"', 'blinking-element" style="margin-left: 4px"') + this.textSVG + this.latencyWarningIcon + '</div>'
	protected voidWarningText = Language.Get(Messages.MALFUNCTION_VOID_WARNING)
	protected voidWarningTextSVG = `
					<svg style="width: 100%;" viewBox="0 0 ${(this.voidWarningText.length * Math.ceil(509 / 36))} 30" preserveAspectRatio="none">
						<text style="fill: white;" x="50%" text-anchor="middle" y="25">${this.voidWarningText}</text>
					</svg>
	`
	protected voidWarningDIV = `
			<div class="void-warning void-warning-canvas-player-fix">
				<div>
					${this.voidWarningTextSVG}
				</div>
			</div>
	`
	protected silhouetteVisible = false
	protected silhouetteHTML = `
							${this.latencyWarning}
							<div style="border-bottom: ${this.borderSize}px solid black; width: ${this.videoWidth}px; height: ${this.videoHeight}px; ">
								<div style="position: absolute; top: -99px; left: -11px">
									<div id="silhouette_play_button" style="transform: scale(0.9)">	
										${Icons_SVG.Silhouette_PLAY}
									</div>
								</div>
							</div>
	`
	protected silhouetteBG = `<img style="background-color: black; width: ${this.videoWidth}px; height: ${this.videoHeight}px; border: ${this.borderSize}px solid ${this.borderColor}; border-radius: 5px;" src='' />`

	/**
	 * CSS POSITIONS FOR BUTTONS
	 * Fullscreen button: bottom: 15px; right: 15px;
	 * Pause button: bottom: 15px; left: 15px;
	 */
	protected HTML: string = `
	${this.latencyWarning}
	<div draggable="false" class="unselectable" id="video_refresh_button" style="display: none; position: absolute; z-index: 9998; bottom: 15px; right: 15px; color: white;">
		<img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="refresh_video_button" src='data:image/svg+xml;utf8,${this.scene.game.device.os.iOS ? Icons_SVG.RefreshSVG : Icons_SVG.FullscreenSVG}' />
	</div>
	<div draggable="false" class="unselectable" id="video_game_fullscreen_button" style="display: none; position: absolute; z-index: 9998; top: 15px; left: 15px; color: white;">
		<img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="refresh_video_button" src='data:image/svg+xml;utf8,${Icons_SVG.FullscreenSVG}' />
	</div>
	<div draggable="false" class="unselectable" id="video_stop_button" style="position: absolute; z-index: 9998; bottom: 15px; right: 15px; color: white;">
		<img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="stop_video_button" src='${Icons_SVG.PauseButton}' />
	</div>
	
	<iframe id="iframe_video_stream" name="" allow="fullscreen" top="0" left="0" style="border: ${this.borderSize}px solid ${this.borderColor}; border-radius: 5px; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: -moz-none; -o-user-select: none; user-select: none; pointer-events: none" src="./embed_autoplay.html" width="` + this.videoWidth + `" height="` + this.videoHeight + `" frameborder="0" scrolling="no" style="overflow: hidden;">Your device cannot play the video.</iframe>
	
	<div draggable="false" class="unselectable" id="global_mute_unmute_button" style="display: none; position: absolute; z-index: 9998; top: 5px; left: 15px; color: white;">
		<img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="global_mute_unmute_button" src='data:image/svg+xml;utf8,${Icons_SVG.SpeakerOn}' />
	</div>
	${this.voidWarningDIV}
	`
	protected divVideoElement = `	<div style="border: ${this.borderSize}px solid ${this.borderColor}; border-radius: 5px; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: -moz-none; -o-user-select: none; user-select: none; pointer-events: none" width="` + this.videoWidth + `" height="` + this.videoHeight + `"> <canvas width="` + this.videoWidth + `" height="` + this.videoHeight + `" id="video-canvas"></canvas> </div> `
	protected videoContainer: HTMLElement
	protected sourceDimensions = { widht: 0, height: 0 }
	protected CSS = `#iframe_video_stream {
                        position: absolute; left: 50%; top: 50%;
                        transform: translateX(-50%) translateY(-50%);
                        width: 250px;
                        transition: all 1s ease-in-out;
                    }
                    #iframe_video_stream:hover {
                        width: 400px;
                    }`
}